import { Pipe, PipeTransform } from '@angular/core';
import { SqiConfiguration } from '../../project/models/project-configuration';
import { Statistic } from '../models/trip-overview';

@Pipe({
  name: 'parseTripSqi'
})
export class ParseTripSqiPipe implements PipeTransform {

  transform(statistics: Statistic[], sqiConfiguration: SqiConfiguration): Statistic | undefined {
    return statistics.find(stat => stat.sqiId === sqiConfiguration.id);
  }

}
